import { render } from "./ContactViewQuestion.vue?vue&type=template&id=6dba52e7"
import script from "./ContactViewQuestion.vue?vue&type=script&lang=js"
export * from "./ContactViewQuestion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__